import React from 'react'
import classNames from 'classnames'
import styles from './index.module.css'

export default ({ medium }) => (
  <div className={classNames(styles.container, medium && styles.medium)}>
    El Backo
  </div>
)
